import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Typography } from '@mui/material';
import { setOpenPopup } from '#action/project/users-popup';
import UserPopup from '#component/user/popup';
import { ShowMoreContainer } from '#component/project/dashboard/cards/styles';
import ArrowRightButton from '#component/general/arrow-right-button';

const UsersButton = ({ project }) => {
  const dispatch = useDispatch();
  const [openUserPopup, setOpenUserPopup] = useState(false);
  const count = project.users;

  const handleOpenUserPopup = () => {
    setOpenUserPopup(!openUserPopup);
    dispatch(setOpenPopup(!openUserPopup));
  };

  if (!count) {
    return null;
  }

  return (
    <>
      <ShowMoreContainer>
        <Typography color="textSecondary" fontWeight="bold">
          {count}
        </Typography>
        <ArrowRightButton onClickArrowRight={handleOpenUserPopup} />
      </ShowMoreContainer>
      {(openUserPopup) &&
        <UserPopup
          project={project}
          open={openUserPopup}
          openedFromCreateForm={false}
          handleClose={handleOpenUserPopup}
        />}
    </>
  );
};

export default UsersButton;
